import React from 'react';
import type { SearchIndex } from 'algoliasearch';
import { PRODUCT_NAME_ID } from '@css-xp/ppc-constants';

export const useSearchHelpArticles: (
  indexInAlgolia: SearchIndex
) => {
  searchHelpArticles: (query: string) => Promise<any>;
} = (indexInAlgolia: SearchIndex) => {
  const searchHelpArticles = React.useCallback(
    async (query: string): Promise<any> =>
      (
        await indexInAlgolia.search(query, {
          facetFilters: [`productNameId:${PRODUCT_NAME_ID}`, 'order: 1'],
        })
      ).hits,
    [indexInAlgolia]
  );

  return { searchHelpArticles };
};
